import React, { useState } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiPackage } from 'react-icons/fi';
import { normalizeMediaUrl } from '../../config/apiConfig';

export default function PacksList({ packs, loading, onEdit, onDelete, onNew }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPacks = packs.filter(pack =>
    (pack.title || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={styles.spinner} />
        <p>Carregando packs...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.toolbar}>
        <input
          type="text"
          placeholder="Buscar pack..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />
        <button onClick={onNew} style={styles.btnPrimary}>
          <FiPlus size={18} /> Novo Pack
        </button>
      </div>

      {filteredPacks.length === 0 ? (
        <div style={styles.empty}>
          <FiPackage size={48} color="#ccc" />
          <p>Nenhum pack encontrado</p>
          <button onClick={onNew} style={styles.btnPrimary}>
            Criar primeiro pack
          </button>
        </div>
      ) : (
        <div style={styles.grid}>
          {filteredPacks.map(pack => (
            <div key={pack.id} style={styles.card}>
              <div style={styles.cardImage}>
                {pack.image ? (
                  <img src={normalizeMediaUrl(pack.image)} alt={pack.title} style={styles.image} />
                ) : (
                  <div style={styles.placeholderImage}>
                    <FiPackage size={32} color="#999" />
                  </div>
                )}
              </div>
              <div style={styles.cardContent}>
                <h3 style={styles.cardTitle}>{pack.title || 'Sem título'}</h3>
                <p style={styles.cardPrice}>{pack.price || 'R$ 0,00'}</p>
                {pack.productIdAndroid && (
                  <div style={styles.productIds}>
                    <div style={styles.productIdRow}>
                      <span style={styles.productIdLabel}>Android:</span>
                      <code style={styles.productIdValue}>{pack.productIdAndroid}</code>
                    </div>
                    <div style={styles.productIdRow}>
                      <span style={styles.productIdLabel}>iOS:</span>
                      <code style={styles.productIdValue}>{pack.productIdIOS}</code>
                    </div>
                  </div>
                )}
                <p style={styles.cardDescription}>
                  {(pack.description || '').substring(0, 80)}
                  {(pack.description || '').length > 80 ? '...' : ''}
                </p>
                <div style={styles.cardMeta}>
                  <span style={styles.badge}>
                    {(pack.questions || []).length} perguntas
                  </span>
                  {pack.locked && <span style={styles.badgeLocked}>Bloqueado</span>}
                  {pack.showInDiary === false && (
                    <span style={styles.badgeInactive}>Não aparece no diário</span>
                  )}
                  {pack.showInDiary !== false && (
                    <span style={styles.badgeDiary}>Ativo no diário</span>
                  )}
                </div>
              </div>
              <div style={styles.cardActions}>
                <button
                  onClick={() => onEdit(pack)}
                  style={styles.btnEdit}
                  title="Editar pack"
                >
                  <FiEdit2 size={16} />
                </button>
                <button
                  onClick={() => onDelete(pack.id)}
                  style={styles.btnDelete}
                  title="Excluir pack"
                >
                  <FiTrash2 size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  toolbar: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  searchInput: {
    flex: '1 1 300px',
    padding: '10px 14px',
    border: '1px solid #d9dbe7',
    borderRadius: 10,
    fontSize: 14,
    outline: 'none',
  },
  btnPrimary: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 16px',
    background: '#1f6feb',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 60,
    color: '#666',
  },
  spinner: {
    width: 40,
    height: 40,
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #1f6feb',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 60,
    color: '#666',
    gap: 16,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: 20,
  },
  card: {
    background: '#fff',
    border: '1px solid #e8e9ef',
    borderRadius: 14,
    overflow: 'hidden',
    transition: 'box-shadow 0.2s',
    position: 'relative',
  },
  cardImage: {
    width: '100%',
    height: 160,
    overflow: 'hidden',
    background: '#f5f6fb',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  placeholderImage: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f6fb',
  },
  cardContent: {
    padding: 16,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 700,
    margin: '0 0 8px 0',
    color: '#111',
  },
  cardPrice: {
    fontSize: 16,
    fontWeight: 600,
    color: '#1f6feb',
    margin: '0 0 8px 0',
  },
  productIds: {
    background: '#f5f6fb',
    border: '1px solid #e8e9ef',
    borderRadius: 8,
    padding: 8,
    marginBottom: 10,
    fontSize: 11,
  },
  productIdRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginBottom: 4,
  },
  productIdLabel: {
    fontWeight: 600,
    color: '#666',
    minWidth: 55,
  },
  productIdValue: {
    fontFamily: 'monospace',
    fontSize: 11,
    color: '#1f6feb',
    background: '#fff',
    padding: '2px 6px',
    borderRadius: 4,
    border: '1px solid #d9dbe7',
  },
  cardDescription: {
    fontSize: 13,
    color: '#666',
    lineHeight: 1.5,
    margin: '0 0 12px 0',
  },
  cardMeta: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
  },
  badge: {
    padding: '4px 10px',
    background: '#eef4ff',
    color: '#1f6feb',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
  },
  badgeLocked: {
    padding: '4px 10px',
    background: '#fff3e6',
    color: '#b86e00',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
  },
  badgeDiary: {
    padding: '4px 10px',
    background: '#e6f7f0',
    color: '#0d9488',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
  },
  badgeInactive: {
    padding: '4px 10px',
    background: '#fee',
    color: '#d73a49',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
  },
  cardActions: {
    display: 'flex',
    gap: 8,
    padding: 12,
    borderTop: '1px solid #f0f0f5',
    background: '#fafbff',
  },
  btnEdit: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 12px',
    background: '#f5f6fb',
    color: '#1f6feb',
    border: '1px solid #d9dbe7',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
  },
  btnDelete: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 12px',
    background: '#fff',
    color: '#d73a49',
    border: '1px solid #d9dbe7',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
  },
};
